import { Options, Vue } from 'vue-class-component';
import HeaderStepper from '../header-stepper/index.vue';
import EoiWording from '../../assets/config/eoi-wording.json';
import { NavStep } from '../header-stepper/nav-step';
import { Inject } from 'vue-property-decorator';
import { RouteN } from '@/constants/route-name';
import Review from '../review/index.vue';
import LoadingSpinner from '@/components/loading-spinner/index.vue';
import store from '@/store';
import { EventEmitter } from 'events';
import { EoiFormView } from '@/modules/typescript-cmpApi-client/models';
import { CMPApi } from '@/modules/cmp-api';
import { AppInsights } from '@/appInsights';

@Options({
  components: {
    HeaderStepper,
    LoadingSpinner,
    Review,
  }
})
export default class EoiReview extends Vue {
  navSteps: NavStep[] = [];

  private isLoadingData = true;
  private navbarText = 'Review Your EOI Application';
  private backButtonVisible = true;
  private backButtonText = 'Back To Dashboard';
  private nextButtonText = 'Edit This EOI Application';
  private canSubmit = true;

  @Inject({ from: 'apiService', default: new CMPApi() })
  private apiService!: CMPApi;

  @Inject({ from: 'eventController', default: new EventEmitter })
  private eventCtrl!: EventEmitter;

  private ai = new AppInsights;

  private eoiForm: EoiFormView = {};
  private eoiEndDate = '';
  private committeeYear = '';

  mounted() {
    window.scrollTo(0, 0);
    // check if eoi from is in progress
    const eoiString = window.sessionStorage.getItem('eoiForm');
    this.eoiForm = eoiString == null ? null : JSON.parse(eoiString);
    if (this.eoiForm == null || !this.eoiForm.yearId ) {
      this.eventCtrl.emit('show-snackbar', 'error', 'Error on loading EOI from data..');
      this.ai.trackException('Error getting details info: ' + 'Error on loading EOI from data');
      this.eventCtrl.emit('isLoadingData', false);
      this.$router.push('/dashboard');
    } else {
      this.committeeYear = this.eoiForm.year.committeeYear;
      this.eoiEndDate = this.eoiForm.year.eoiPeriodEnd;
      this.eventCtrl.on('isLoadingData', this.showLoading);
    }

  }

  unmounted() {
    this.eventCtrl.removeListener('isLoadingData', this.showLoading);
  }

  private showLoading(isLoading: boolean) {
    this.isLoadingData = isLoading;
  }

  get pageTitle(): string {
    return "Expression of Interest - Membership of Law Society Committees for"
  }

  get pageHeader(): string {
    return EoiWording[0].overview['pageHeader']
  }

  private backButton(): void {
    this.$router.push({ name: RouteN.CMP.Dashboard.n });
  }

  private eoiApply() {
    const pageSection = 'overview';
    this.$router.push({ name: 'EoiApply', query: { sec: pageSection, committeeYear: this.eoiForm.year.committeeYear } });
  }

}
